import { random } from 'lodash';
import { useCallback, useEffect, useMemo } from 'react';

const timeOutIds: any = {};

export function useTimeOut() {
  const timerPropId = useMemo(() => random(), []);

  const clearTimeOut = useCallback(() => {
    if (timeOutIds[timerPropId]) {
      clearTimeout(timeOutIds[timerPropId]);
      delete timeOutIds[timerPropId];
    }
  }, []);

  const setTimeOut = useCallback((callback: () => void, delay: number) => {
    const id = setTimeout(() => {
      if (!timeOutIds[timerPropId]) {
        return;
      }
      callback();
    }, delay);
    timeOutIds[timerPropId] = id;
  }, []);

  useEffect(() => {
    return () => {
      clearTimeOut();
    };
  }, []);

  return {
    setTimeOut,
    clearTimeOut,
  };
}
